export default [
  {
    title: "White Glove & Cap Table",
    questions: [
      {
        question: `What is included?`,
        answer: `Anything that can be performed inside our cap table software we will do for you. This includes but is not limited to: populating your cap table with data, adding/deleting/editing members, adding/deleting/editing rounds of financing, generating reports, and running dilution/exit simulations.`,
      },
      {
        question: `What is not included?`,
        answer: `Anything that is outside the scope of our software is not included. We do not provide legal/accounting advice and do not generate legal documents. `,
      },
      {
        question: `Do I still need a lawyer, accountant, or CFO?`,
        answer: `Yes, we are not a substitute for these service providers. However, by allowing us to manage your cap table instead of them you can dramatically reduce your bill since their hourly rates can be quite expensive. This allows you to focus their work on what they are uniquely qualified for.`,
      },
      {
        question: `Do you guarantee the accuracy of the data? `,
        answer: `No. We do our best with the information provided but we are not certified to provide legal cap table audits. However, we do have third parties who provide this service. If you are interested in getting a cap table audit please email us: support@t12.ai `,
      },
      {
        question: `Can I still access and manage my cap table myself?`,
        answer: `You and everyone else on your cap table (including your service providers) will get access to your cap table. You can login and make edits/updates yourself if you like. You can also provide admin or view-only access to your service providers who can also review the information for accuracy and make changes/run reports/etc.`,
      },
      {
        question: `What levels of access do you support?`,
        answer: `We provide two levels of admin access: admin (full controls), view-only (can see everything but can’t make changes). Users are only able to see their specific cap table information and cannot see detailed information about other cap table members. We provide two levels of user access: summary (shows their share count/vesting/amount invested) or detailed (also shows their percentage ownership and dollar value of holdings if there has been a priced round).`,
      },
    ],
  },
  {
    title: `Onboarding & Support`,
    questions: [
      {
        question:
          "I purchased White Glove, now what? How does onboarding work? ",
        answer:
          "Once you have signed up for T12 White Glove you will receive an email with a link to a secure google drive. You simply upload the documents to the google drive link and we will populate your cap table for you. If you would prefer you can also email documents to whiteglove@t12.ai. Our support team will reach out to you with any questions and to set up a time to review once all the data has been onboarded. Once you confirm all data is correct we can invite cap table members for you and also manage their onboarding to the platform. ",
      },
      {
        question: `What does 24 hour turnaround mean?`,
        answer: `We will respond to your request within 24 hours. The time needed to fulfill the request will vary based upon the complexity of the requested task. Our goal will be to get your issue resolved as fast as possible. For simple requests like ‘please add the latest investor to our cap table’ it generally takes about 1 business day. `,
      },
    ],
  },
  {
    title: "Data & Security",
    questions: [
      {
        question: "Do you spam my investors?",
        answer:
          "No. We will never spam or solicit your investors. We will only invite your investors to your cap table once you have requested we do so. Our software will also send them emails related to the use of the product as necessary.",
      },
      {
        question: "How does T12.ai protect my data?",
        answer:
          "Our platform provides comprehensive security solutions: enterprise-grade encryption, secure data storage, and robust access management. We are also pursuing industry-standard certifications, including SOC 2 compliance.",
      },
    ],
  },
];
